import React from 'react';
import { Select2 } from '@economic/taco';
import { useCollectionQuery } from '~/app/shared/hooks/useCollectionQuery';
import { AccountModel } from '~/app/views/Accounts';
import { AccountTypeNumber } from '~/types';

// Use with <Field/> as Select2 is not compatible with <Field.Dropdown/>
// Example:
// <Field name="feeAccount" label={t`Fee account`} as={AccountFromCoADropdown} />

interface Props {
    filterByType?: AccountTypeNumber;
}

export const AccountFromCoADropdown = ({ filterByType, ...props }: Props) => {
    const { data } = useCollectionQuery<AccountModel>(
        `/accounts/collection${filterByType ? `?filter=typeid$eq:${filterByType}` : ''}`,
        true
    );

    return (
        <Select2 className="w-20" {...props}>
            {data.map(item => (
                <Select2.Option key={item.number} value={item.number}>
                    {item.number + ' - ' + item.name}
                </Select2.Option>
            ))}
        </Select2>
    );
};
